import { Injectable } from '@angular/core';
import { regionsNvilles } from '../data/regionsNvilles';

export const Pattern = {
  url: '^(https?:\\/\\/)?' + // protocol
  '((([a-zA-Z\\d]([a-zA-Z\\d-]{0,61}[a-zA-Z\\d])*\\.)+' + // sub-domain + domain name
  '[a-zA-Z]{2,13})' + // extension
  '|((\\d{1,3}\\.){3}\\d{1,3})' + // OR ip (v4) address
  '|localhost)' + // OR localhost
  '(\\:\\d{1,5})?' + // port
  '(\\/[a-zA-Z\\&\\d%_.~+-:@]*)*' + // path
  '(\\?[a-zA-Z\\&\\d%_.,~+-:@=;&]*)?' + // query string
  '(\\#[-a-zA-Z&\\d_]*)?$', // fragment locator
  number: '[0-9]+',
  email: '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$',
  date: '^([0-9]{1,2})[/|-]([0-9]{1,2})[/|-]([0-9]{4})$'
};

@Injectable()
export class FormService {

  private cache: any = null;
  private years = [];

  constructor() {
    const storageCache = localStorage.getItem('cache');
    if (storageCache) {
      this.cache = JSON.parse(storageCache);
    }
    // Set contribution years
    const currentYear = new Date().getFullYear();
    for (let year = 2000; year <= currentYear; year++) {
      this.years.unshift(year.toString());
    }
    //console.log(this.years);
  }

  getYears() {
    return this.years;
  }

  getAcademyList() {
    return regionsNvilles.map(region => region.name);
  }

  getDirectionList(academy: string = null) {
    //console.log(academy);
    let directionList = [];
    if (academy) {
      const region: any = regionsNvilles.find(region => region.name === academy);
      //console.log(region);
      if (region && region.villes) {
        directionList = region.villes;
      }
    }
    if (directionList.length === 0) {
      const villes = regionsNvilles.map(region => region.villes);
      //console.log(villes);
      directionList = villes.reduce((a, b) => a.concat(b), []);
    }
    return directionList;
  }

  getCache(key: string | string[] = null, defaultValue: any = null) {
    if (key) {
      let value = null;
      if (this.cache) {
        value = key.constructor === Array ? this.cache[key[0]][key[1]] : this.cache[key as string];
      }
      return value || defaultValue;
    } else {
      return this.cache;
    }
  }

  setCache(data: any) {
    this.cache = data;
    localStorage.setItem('cache', JSON.stringify(this.cache));
  }
}
